import { useEffect, useState } from "react";
import { Star, X, ExternalLink } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { getGoogleReviewNudge, ackGoogleReviewNudge } from "@/lib/api";

export const GoogleReviewNudge = () => {
  const [show, setShow] = useState(false);
  const [url, setUrl] = useState("");

  useEffect(() => {
    getGoogleReviewNudge()
      .then((n) => {
        if (n?.show && n?.url) {
          setUrl(n.url);
          setShow(true);
        }
      })
      .catch(() => {});
  }, []);

  const rate = () => {
    // Fire-and-forget ack, then open Google in a new tab
    ackGoogleReviewNudge("clicked").catch(() => {});
    window.open(url, "_blank", "noopener,noreferrer");
    setShow(false);
  };

  const dismiss = () => {
    ackGoogleReviewNudge("dismiss").catch(() => {});
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="google-review-nudge"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.25 }}
          className="relative rounded-2xl border border-accent/40 bg-gradient-to-br from-accent/10 to-background p-6"
        >
          <button
            data-testid="google-review-dismiss"
            onClick={dismiss}
            aria-label="Dismiss"
            className="absolute top-3 right-3 grid place-items-center h-8 w-8 rounded-full text-muted-foreground hover:bg-secondary/60 transition"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="flex items-center gap-1 mb-3" aria-hidden>
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-5 w-5 fill-accent text-accent" />
            ))}
          </div>

          <h3 className="font-serif text-xl font-bold">Loving Lectura?</h3>
          <p className="mt-1 text-sm text-muted-foreground max-w-md">
            Take 30 seconds to leave a Google review — it genuinely helps other students find us, and it makes our week.
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              data-testid="google-review-cta"
              onClick={rate}
              className="inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground px-5 py-2.5 text-sm font-semibold hover:opacity-90 transition"
            >
              Rate us on Google <ExternalLink className="h-3.5 w-3.5" />
            </button>
            <button
              data-testid="google-review-later"
              onClick={dismiss}
              className="inline-flex items-center gap-2 rounded-full border-2 border-border px-5 py-2.5 text-sm font-semibold hover:bg-secondary/60 transition"
            >
              Not now
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
